module.exports = __webpack_public_path__ + "img/bitski.8e9a9e85.svg";